export default {
  characteristicsReviewBatteryHelperText: {
    id: 'product_comparison_reviews_characteristics_review_battery_helper_text',
    defaultMessage:
      '*Refurbished devices sold on Back Market offer at least 80% of this maximum power',
  },
}
